<template>
	<header :class="`header ${headerWhite} header--fixed-${fixed} header--fixed-${fixed}-${color}`">
		<div class="header__mob" :class="{'opened': menu}">
			<div class="header__mob-share">
				<div class="header__mob-share-label">Поделитесь проектом</div>
				<div class="header__mob-share-lsit">
					<yandex-share :services="['facebook','vkontakte','twitter','odnoklassniki']" @share="shareEvent" />
				</div>
			</div>
		</div>
		<div class="container">
			<div class="header__content">
				<div class="header__left">
					<div class="header__logo" @click="sendEvent('logo_korea', 'm_logo_korea')">
						<router-link to="/"></router-link>
					</div>
					<div class="header__back" v-if="!headerWhite" @click="sendEvent(backEvent, backEventm)">
						<a href="javascript:void(0)" @click="$router.go(-1)">
							<i></i>
							<span>Назад</span>
						</a>
					</div>
				</div>
				<div class="header__burger" @click="$emit('toggleMenu')" :class="{'opened': menu}">
					<span></span>
					<span></span>
					<span></span>
				</div>
				<div class="header__menu" v-if="this.$route.path == '/'" :class="{'opened': menu}">
					<div class="header__menu-item" @click="$emit('goto', 1)" v-bind:class="{'header__menu-item--active': active === 0 || active === 1}">
						<a href="javascript:void(0)" @click="sendEvent('menyu_glavnaya', 'm_menyu_glavnaya')">Главная</a>
					</div>
					<div class="header__menu-item header__menu-item--line" @click="$emit('goto', 3)" v-bind:class="{'header__menu-item--active': active === 2}">
						<a href="javascript:void(0)" @click="sendEvent('menyu_uznaj_koreyu', 'm_menyu_uznaj_koreyu')">Узнай Корею</a>
					</div>
					<div class="header__menu-item header__menu-item--blue" @click="$emit('goto', 4)" v-bind:class="{'header__menu-item--active': active === 3}">
						<a href="javascript:void(0)" @click="sendEvent('menyu_karta_korei', 'm_menyu_karta_korei')">Карта Кореи</a>
					</div>
					<div class="header__menu-item header__menu-item--blue" @click="$emit('goto', 5)" v-bind:class="{'header__menu-item--active': active === 4}">
						<a href="javascript:void(0)" @click="sendEvent('menyu_konkurs', 'm_menyu_konkurs')">Конкурс</a>
					</div>
				</div>
				<div class="header__menu header__menu--inner" v-if="this.$route.path !== '/'" :class="{'opened': menu}">
					<div class="header__menu-item" @click="sendEvent('menyu_glavnaya', 'm_menyu_glavnaya')">
						<router-link to="/">Главная</router-link>
					</div>
					<div class="header__menu-item header__menu-item--line" @click="sendEvent('menyu_uznaj_koreyu', 'm_menyu_uznaj_koreyu')">
						<router-link to="/#3">Узнай Корею</router-link>
					</div>
					<div class="header__menu-item header__menu-item--blue" @click="sendEvent('menyu_karta_korei', 'm_menyu_karta_korei')">
						<router-link to="/#4">Карта Кореи</router-link>
					</div>
					<div class="header__menu-item header__menu-item--blue" @click="sendEvent('menyu_konkurs', 'm_menyu_konkurs')">
						<router-link to="/#5">Конкурс</router-link>
					</div>
				</div>
				<div class="header__right">
					<div class="header__right-label">Спецпроект</div>
					<div class="header__right-logo" @click="sendEvent('logo_lenta', 'm_logo_lenta')">
						<a href="https://lenta.ru" target="_blank"></a>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
	import Vue from 'vue';
	import YandexShare from '@cookieseater/vue-yandex-share';
	Vue.component('yandex-share', YandexShare);
	export default {
		name: 'Header',
		props: {
			headerWhite: String,
			menu: Boolean,
			active: Number,
			fixed: Boolean,
			color: String,
			backEvent: String,
			backEventm: String,
		},
		methods: {
			shareEvent(soc) {
				this.$gtag.event('click', {event_category: 'link', 'event_label': 'share'});
        this.$gtag.event('click', {event_category: 'link','event_label': 'm_share_'+soc});
			},
			sendEvent(event, eventMob) {
				if (window.innerWidth > 960) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': event});
				} else {
					this.$gtag.event('click', {event_category: 'link', 'event_label': eventMob});
				}
			},
		}
	}
</script>

<style lang="sass">
	.header
		font-family: 'Favorit'
		position: fixed
		top: 0
		left: 0
		z-index: 200
		width: 100%
		color: #fff
		padding-top: vw(20px)
		@media screen and (max-width: 1000px)
			padding-top: vwm(20px)
			position: absolute
			.header__back a
				transition-delay: 0s
		&--fixed-true
			@media screen and (max-width: 1000px)
				position: fixed
				background-color: $red
				height: vwm(48px)
				background-image: url(../assets/images/bg.png)
				&-yellow
					background-color: $yellow
				.header__content
					margin-top: vwm(-4px)
				.header__logo
					display: none
				.header__right
					display: none
				.header__burger
					margin-left: auto
					margin-right: auto
				.header__back
					position: absolute
					a
						margin-top: 0
		&__burger
			display: none
			position: relative
			z-index: 200
			@media screen and (max-width: 760px)
				display: block
				margin-left: vwm(15px)
			span
				width: 20px
				height: 2px
				display: block
				background-color: #fff
				margin-bottom: 4.5px
				transition: all 300ms
			&.opened
				span
					&:nth-child(1)
						transform: rotate(45deg) translateY(9px)
						margin-left: 9px
					&:nth-child(2)
						width: 0
					&:nth-child(3)
						transform: rotate(-45deg) translateY(-9px)
						margin-left: 9px
		&__mob
			display: none
			@media screen and (max-width: 760px)
				display: block
				width: 100vw
				height: 100vh
				background-color: #033250
				background-image: url(../assets/images/bg.png)
				top: -200vh
				left: 0
				position: fixed
				z-index: 100
				transition: all 100ms
				&.opened
					top: 0
			&-share
				padding-left: vwm(38px)
				padding-top: vwm(450px)
				&-label
					font-size: vwm(22px)
				.ya-share2__list
					display: flex !important
					align-items: center !important
					width: vwm(253px)
					justify-content: space-between
				.ya-share2__container_size_m
					padding-top: vwm(32px)
				.ya-share2__item_service_facebook .ya-share2__icon
					width: vwm(20px) !important
					height: vwm(40px) !important
					background-size: contain !important
					background-repeat: no-repeat !important
					background-image: url(../assets/img/facebook-line.svg) !important
				.ya-share2__item_service_vkontakte .ya-share2__icon
					width: vwm(43px) !important
					height: vwm(26px) !important
					background-size: contain !important
					background-repeat: no-repeat !important
					background-image: url(../assets/img/vk-line.svg) !important
				.ya-share2__item_service_twitter .ya-share2__icon
					width: vwm(39px) !important
					height: vwm(35px) !important
					background-size: contain !important
					background-repeat: no-repeat !important
					background-image: url(../assets/img/twitter-line.svg) !important
				.ya-share2__item_service_odnoklassniki .ya-share2__icon
					width: vwm(29px) !important
					height: vwm(48px) !important
					background-size: contain !important
					background-repeat: no-repeat !important
					background-image: url(../assets/img/ok-line.svg) !important
				.ya-share2__badge
					background: none !important
		&__back
			a
				font-size: vw(12px)
				color: $white
				text-decoration: none
				display: flex
				align-items: center
				transition: all 300ms
				transition-delay: 300ms
				@media screen and (max-width: 1000px)
					font-size: vwm(12px)
					margin-top: vwm(10px)
				i
					background-image: url(../assets/img/arrow.svg)
					background-size: contain
					background-repeat: no-repeat
					width: vw(20px)
					height: vw(8px)
					display: block
					margin-right: vw(10px)
					transition: all 300ms
					transition-delay: 300ms
					@media screen and (max-width: 1000px)
						margin-right: vwm(10px)
						width: vwm(20px)
						height: vwm(8px)
		&--white
			.header__right-logo a
				background-image: url(../assets/img/lenta-light.svg)
			.header__right-label
				color: $white
			.header__menu-item--blue a
				color: $white
		&__logo
			position: relative
			z-index: 200
			a
				width: vw(80px)
				height: vw(51px)
				margin-bottom: vw(12px)
				background-image: url(../assets/img/logo.svg)
				display: block
				background-size: contain
				background-repeat: no-repeat
				@media screen and (max-width: 1000px)
					width: vwm(80px)
					height: vwm(51px)
		&__content
			display: flex
			justify-content: space-between
		&__right
			position: relative
			z-index: 200
			display: flex
			@media screen and (max-width: 1000px)
				flex-direction: column-reverse
				align-items: flex-end
				justify-content: flex-end
			&-label
				font-size: vw(10px)
				text-transform: uppercase
				color: $black
				margin-right: vw(8px)
				letter-spacing: vw(1.3px)
				@media screen and (max-width: 1000px)
					font-size: vwm(10px)
					margin-right: 0
					letter-spacing: vwm(1.1px)
					margin-top: vwm(5px)
			&-logo
				a
					width: vw(91px)
					height: vw(15px)
					background-image: url(../assets/img/lenta.svg)
					display: block
					background-size: contain
					background-repeat: no-repeat
					@media screen and (max-width: 1000px)
						width: vwm(91px)
						height: vwm(15px)
		&__menu
			display: flex
			margin-top: vw(3px)
			margin-left: vw(94px)
			&--inner
				.header__menu-item a
					@media screen and (max-width: 1000px)
						color: #fff !important
			@media screen and (max-width: 1000px)
				display: none
				&.opened
					display: block !important
					position: fixed
					top: vwm(116px)
					margin-left: vwm(11px)
					z-index: 200
			&-item
				margin-left: vw(19px)
				margin-right: vw(19px)
				font-family: 'Montserrat'
				@media screen and (max-width: 1000px)
					margin-bottom: vwm(41px)
				a
					font-size: vw(14px)
					color: $white
					text-decoration: none
					@media screen and (max-width: 1000px)
						font-size: vwm(40px)
				&--blue
					a
						color: $blue
				&--active
					text-decoration: underline
					@media screen and (max-width: 1000px)
						text-decoration: none !important
	.header.undefined
			@media screen and (max-width: 1000px)
				.header__right-logo a
					background-image: url(../assets/img/lenta-light.svg)
				.header__right-label
					color: #fff		
</style>